var $7cacc29a1e5f4fbe$exports = {};
$7cacc29a1e5f4fbe$exports = {
    "Clear search": `Vymaza\u{165} vyh\u{13E}ad\xe1vanie`
};


export {$7cacc29a1e5f4fbe$exports as default};
//# sourceMappingURL=sk-SK.module.js.map
